import { axios } from "../../lib/axios";

export type PatchVideoPayload = {
  isDemo?: boolean;
  name?: string;
  url?: string;
};

export const PatchVideo = (id: string, payload: PatchVideoPayload) => {
  return axios.patch(`/video/${id}`, payload).then((res) => res.data);
};
